// This service provides the interface between the app and browser location/URL
import { createBrowserHistory } from "history";
import { AppUrl } from "../../config";
export default createBrowserHistory();
export const hist = createBrowserHistory({
  basename: process.env.NODE_ENV === 'test' ? '' : 'bankfind-suite',
});
// see also: https://www.npmjs.com/package/history

export const getLocation = () => {
  // Returns browser location.search
  if (!window.location.pathname.startsWith("/bankfind-suite")) {
    hist.push(AppUrl("HomePage"));
  }
  return hist.location;
};

export const setLocation = (searchString: string) => {
  // Set the browser location.search
  // Input: stringified search string
  // Results: set string contents in browser location.search

  hist.push(
    window.location.pathname.replace(`/bankfind-suite`, "") + searchString,
  );
};

export const startBrowserHistoryListener = (
  store: any,
  withinPath: string,
  onHistoryChange: any,
) => {
  // set up listener for changes (i.e. back button)
  // Input: store data and callback function to call upon history change
  // Result: callback will be dispatched when history changes

  hist.listen((location, action) => {
    // only trigger if we are in the correct path
    //if (location.pathname === withinPath) {
    store.dispatch(onHistoryChange(store, location.search));
    //}
  });
};
